import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BaseService } from './base.service';



@Injectable()
export class ServiceService extends BaseService {

  private baseFormChangeSource = new Subject();
  baseFormChange$ = this.baseFormChangeSource.asObservable();

  getServices(username: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      username: username
    };

    return this.http.post(this.url + 'api/service/getServices', body, { headers: headers });
  }

  getServicesByServiceType(service_type: string, vendor: string, person_type: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      service_type: service_type,
      vendor: vendor,
      person_type: person_type
    };

    return this.http.post(this.url + 'api/service/getServicesByServiceType', body, { headers: headers });
  }

  getRelatedServices(username: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      username: username
    };

    return this.http.post(this.url + 'api/service/getRelatedServices', body, { headers: headers });
  }

  getVpses(username: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      username: username
    };

    return this.http.post(this.url + 'api/service/getVpses', body, { headers: headers });
  }

  getVpsPrices(vpsid) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'token': this.token
    });

    const body = {
      vpsid
    };

    return this.http.post(this.url + 'api/service/getVpsPrices', body, { headers: headers });
  }

}






